<template>
    <div class="scene_container">
        <div class="scene" ref="scene">
            <Slide v-for="(slide, idx) in slides" :key=idx :content=slide :slideIdx=idx :slidesNum=slides.length ref="slides" />
        </div>
    </div>
</template>

<script>
    import Slide from './Slide'
    import smoothscroll from 'smoothscroll-polyfill'

    export default {
        name: "Slider",
        props: { startSlide: { default:0 }, slides: { default:{} } },
        components: { Slide },
        data: () => ({
            cameraSpeed:300, cameraZ:0, cameraZInitial:300, itemMargin:3, lastScrollTop:0, activeSlide:0
        }),
        created(){
            let self = this
            window.scrollTo(0,0)

            self.$root.$on('goToPrev', function(data){ self.goToSlide(data.slideIdx - 1) })
            self.$root.$on('goToNext', function(data){ self.goToSlide(data.slideIdx + 1) })
            self.$root.$on('goToSlide', function(data){ self.goToSlide(data.slideIdx) })
        },
        mounted(){
            let self = this
            self.setSlidesProps()

            //ignore last page scroll, switch slide by parameter
            setTimeout(() => {
                self.setSceneHeight()
                self.goToSlide(this.startSlide)
            }, 200) 

            smoothscroll.polyfill()
            document.addEventListener('scroll', e => self.moveCamera())
            document.addEventListener('keydown', e => self.handleKeydown(e), { passive:false })

            window.addEventListener('resize', () => {console.log('TODO: debounce `setSceneHeight` method'); self.setSceneHeight()})
        },
        methods: {
            setItemZ: (item, zVal) => {
                try {
                    item.style.transform = `translate3D(0, 0, ${zVal}px)`
                } catch(e) {}
            },

            getScrollDirection(){
                let st = this.cameraZ-1, direction;
                direction = st > this.lastScrollTop ? 'down' : 'up'
                this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
                return direction
            },
            
            setSceneHeight(){
                this.$parent.$refs.viewport.style.height = `${window.innerHeight + this.cameraSpeed / this.itemMargin * this.slides.length * this.itemMargin - this.cameraSpeed}px`    // plus 10px for last slide detection
            },

            setSlidesProps(){
                this.$refs.slides.forEach((slide, i, self) => {
                    let zVal = i != 0 ? -this.cameraZInitial : 0
                    this.setItemZ(slide.$el, zVal * i)
                    slide.$el.dataset.slide = zVal * i
                    slide.$el.dataset.slideId = i
                    slide.$el.style.zIndex = self.length - i
                    if(i == 0 || i == 1) slide.$el.style.display = 'block'
                })
            },

            moveCamera(){
                this.cameraZ = window.pageYOffset

                this.setItemZ(this.$refs.scene, this.cameraZ)

                Array.from(document.querySelectorAll('[data-slide]:not(.out)'))//.splice(0,2) // select first two elements – doubtful optimization
                .forEach((elt, i) => {
                    let eltDataSlide = parseInt(elt.dataset.slide)
                    if(i == 0 || i == 1){
                        elt.style.display = 'block'
                        elt.style.pointerEvents = 'all'

                        let opacityVal = parseFloat(1 - (eltDataSlide + this.cameraZ) / 300).toFixed(2)
                        let workingOpacity = parseFloat(opacityVal > 1 ? 1 : (opacityVal < 0 ? 0 : opacityVal))
                        elt.querySelector('.slide_content').style.opacity = workingOpacity-(parseFloat(1.15-opacityVal))
                        elt.style.opacity = workingOpacity+.1
                        
                        if(-eltDataSlide + this.cameraSpeed <= this.cameraZ){
                            elt.classList.add('out')
                            elt.style.display = 'none'
                        }

                        // define active slide on scroll AND on goToSlide
                        if(i == 0 /*&& this.$route.name === 'slides'*/){
                            let intendedSlide = parseInt(-eltDataSlide/this.cameraSpeed)
                            if(Math.abs(-eltDataSlide - this.cameraZ) > this.cameraSpeed / 2){
                                intendedSlide++
                            }
                            if(this.$route.name != 'cases'){
                                if(intendedSlide != 0){    // plus one index for route param
                                    this.$router.push({ name:'slides', params: {slideId:intendedSlide }}).catch(() => {})
                                    this.activeSlide = intendedSlide
                                } else {
                                    this.$router.push({ name:'index' }).catch(() => {})
                                    this.activeSlide = 0
                                }
                            }
                        }

                        if(-eltDataSlide + this.cameraSpeed / 2 <= this.cameraZ) elt.style.pointerEvents = 'none'
                    } else {
                        if(i == 2 && -eltDataSlide - this.cameraSpeed >= this.cameraZ) elt.style.display = 'none'
                    }
                })
                if(this.getScrollDirection() == 'up'){
                    let lastOutEl = this.$refs.slides.filter(slide => slide.$el.classList.contains('out')).slice(-1)[0]
                    if(lastOutEl){
                        let eltDataSlide = lastOutEl.$el.dataset.slide
                        if(parseInt(-eltDataSlide) + this.cameraSpeed > this.cameraZ){
                            lastOutEl.$el.classList.remove('out')
                        }
                    } else {
                    }
                }
            },

            goToSlide(slideNum=0){
                let self = this
                if(slideNum >= 0 && slideNum <= self.slides.length - 1){
                    window.scrollTo({left:0, top:(slideNum) * self.cameraSpeed, behavior:'smooth'})
                } else {
                    console.warn(`[Slider]: goToSlide 'slideNum' arg is ${slideNum}`)
                }
            },

            handleKeydown(e){
                let self = this,
                    direction = 0;
                if(e.keyCode === 38         // down
                    || e.keyCode === 39
                    || e.keyCode === 32
                    || e.keyCode === 35
                    || e.keyCode === 34
                ){
                    direction = 1
                } else if(e.keyCode === 40  // up
                    || e.keyCode === 37
                    || (e.keyCode === 32 && e.shiftKey === true)
                    || e.keyCode === 36
                    || e.keyCode === 33
                ){
                    direction = -1
                }
                if(direction != 0){
                    e.preventDefault()
                    e.stopPropagation()
                    self.goToSlide(self.activeSlide + direction)
                }
            }
        },
        watch: {
            '$route'(to, from){}
        }
    }
</script>

<style lang="scss">
    .scene_container {
        position:fixed; top:0; left:0; width:100%; height:100%; perspective:300px; perspective-origin:(50% 50%); will-change:perspective-origin; transform:translate3d(0, 0, 0);
    }

    .scene {
        position:absolute; z-index:2; top:0; height:100vh; width:100%; transform-style:preserve-3d; transform:translateZ(0px);
    }
</style>